<script>
    import { onMount } from 'svelte';

    import { auth, db, user, functions, hashtag, break_session } from './stores.js';

    import SignIn from './components/SignIn.svelte';


    let loggedIn = false;
    let mode = "chat";
    let errorStatus = "";
    let messages;
    let message;
    let questions;
    let conversation;
    let userSocial;
    let status = "";


    onMount(async () => {
        if ($user){
            loadInfo($user.uid);
        }
        console.log({$break_session})
    });


	$auth.onAuthStateChanged(function(userAuthState) {
        console.log("onAuthStateChanged");
		if(userAuthState){
            console.log('userAuthState');
            loadInfo(userAuthState.uid);
		} else {
			// console.log('onAuthStateChanged no user');
			// $user = null;
		};
	});

    function loadInfo(uid) {
        // get logged in social account
        $db.collection("users").doc(uid).get().then((doc) => {
            if (doc.exists) {
                console.log("User data: ", doc.data());
                userSocial = {...doc.data()};
                console.log("userSocial: ", userSocial);

            } else {
                console.error("No such document");
            }
        }).catch((error) => {
            console.log("Error getting document: ", error);
        });
    };

    const loadIntialMessages = async() => {
        const messagesPage = await conversation.getEvents({ event_type: "text", page_size: 10, order: "desc" });
        const questionsPage = await conversation.getEvents({ event_type: "custom:question", page_size: 10, order: "desc" });
        // messages = Array.from(messagesPage.items);
        // questions = Array.from(questionsPage.items);
        // messages = Object.entries(messagesPage.items);
        // questions = Object.entries(questionsPage.items);
        console.log('initial messages: ', messagesPage);
        console.log('initial questions: ', questionsPage);
        // messages = messagesPage.items;
        // messages = new Map([...messagesPage.items.entries()].sort());
        // questions = new Map([...questionsPage.items.entries()].sort());
        messages = new Map([...messagesPage.items.entries()].sort((a,b) => a[0]-b[0]));
        questions = new Map([...questionsPage.items.entries()].sort((a,b) => a[0]-b[0]));
        console.log('messages: ', messages);
        console.log('questions: ', questions);
    }
    
    async function joinRoom(){
        console.log("joinRoom");
        status = "joining room..."
        try {
            const getJWT = $functions.httpsCallable('getJWT');
            const response = await getJWT({username: $user.username , conversationId: $break_session.conversationId});
            const jwt = response.data.jwt;
            console.log('jwt: ',jwt);
            const client = new NexmoClient({debug:false});
            const app = await client.createSession(jwt);
            conversation = await app.getConversation($break_session.conversationId);
            console.log('joinRoom conversation: ',conversation);  
            //get early messages and questions if any;
            loadIntialMessages();
            //set up event listeners
            conversation.on('text', (sender, event)=>{
                console.log('got text event!: ',sender, event);
                //add event to messages
                // messages = [...messages, ];
                messages.set(event.id,event);
                // messages.set(event.id,{...event, ...sender});
                messages = messages;
                console.log('messages on text: ',messages);
            });
            conversation.on('question', (sender, event)=>{
                console.log('got question event!: ',sender, event);
                //add question to questions
                // questions = [...questions, ]
                questions.set(event.id,event);
                // questions.set(event.id,{...event, ...sender});
                questions = questions;
                console.log('questions on custom event: ',questions);
            });
            loggedIn = true;
        }
        catch (error){
            console.error('error in setup: ', error);
            status = `Error in setup: ${error}`;
        }

    }

    const submitMessage = async() => {
        console.log("submit message!");
        if (mode === 'chat'){
            //send text event
            console.log('send chat message:',message);
            try {
                await conversation.sendText(message);
                console.log('text event sent!');
                message = '';
            }
            catch(error){
                console.error('got an error sending a question: ', error);
                errorStatus = error;
            }

        } else if (mode === 'questions'){
            // send custom event questions
            console.log('send question:',message);
            try {
                await conversation.sendCustomEvent({ type: 'question', body: { question: message, displayName: userSocial.username } });
                console.log('questionEvent sent!');
                message = '';
            }
            catch (error){
                console.error('got an error sending a question: ', error);
                errorStatus = error;
            }
        }
    }

    // const getDisplayName = async (id) => {
    //     console.log("getDisplayName id: ", id);
    //     return await conversation.getMember(id).then((member) => {
    //         console.log("Member: ", member);
    //         return "Bob";
    //     }).catch((error) => {
    //         console.error("error getting member", error);
    //         return "Got an error";
    //     });
    // }


</script>

<section>
    {#if $user}
        {#if loggedIn}
            <section id="chat-qs-container">
                <div id="tabs">
                    <button class:selected="{mode === 'chat'}" on:click="{() => mode = 'chat'}">chat</button>
                    <button class:selected="{mode === 'questions'}" on:click="{() => mode = 'questions'}">questions</button>    
                </div>
                <div id="messagesContainer">
                    {#if mode === 'chat'}
                        <div id="chatContainer">
                            <div id="chat">
                                {#if messages}
                                    {#each [...messages] as [key,value]}
                                        <div class="message" id={key}>
                                            <div class="bubble" class:mine="{value.from === conversation.me.id}">
                                                {value.body.text}
                                            </div>
                                            <div class="author" class:mine="{value.from === conversation.me.id}">
                                                {value._embedded.from_user.display_name}
                                            </div>
                                        </div>
                                    {/each}
                                {/if}
                            </div>
                        </div>
                    {/if}
                    {#if mode === 'questions'}
                        {#if messages}
                            {#each [...questions] as [key,value]}
                                <div class="message" id={key}>
                                    <div class="bubble" class:mine="{value.from === conversation.me.id}">
                                        {value.body.question}
                                    </div>
                                    <div class="author" class:mine="{value.from === conversation.me.id}">
                                        <!-- {value._embedded.from_user.display_name} -->
                                        {value.body.displayName ? value.body.displayName : "N/A"}
                                    </div>
                                </div>
                            {/each}
                        {/if}
        
                    {/if}
                </div>
                <form id="submit-message" on:submit|preventDefault={submitMessage}>
                    <label for="message">Enter {mode==="chat"? 'message' : 'question'}</label>
                    <input type="text" id="message" name="message" bind:value={message} required/>
                    <button type="submit">send</button>
                    <div>{errorStatus}</div>
                </form>
            </section>
        {:else}
            <button on:click={joinRoom}>Join the room</button>
            <br/>{status}
        {/if}
    {:else}
        <div>
            Please sign in to chat and ask questions.
            <SignIn />
        </div>
    {/if}
</section>

<style>

    label {
        display: block;
    }

    input {
        font-size: 16px;
    }


    .selected {
		border-bottom: 2px red solid;
	}

	button {
		text-decoration: none;
        color: #000000;
        background: none;
        border-radius: 5px;
        padding: 5px;
        border: none;
        cursor: pointer;
        font-size: 16px;;
	}

    #login {
        height: 100%;
        display: flex;
        align-items: center;
    }

    #chat-qs-container {
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
    }

    #tabs {
        display: flex;
        justify-content: space-around;
    }

    #messagesContainer {
        height: 100%;
        overflow-y: auto;
        /* display: flex;
        flex-direction: column-reverse; */
        /* flex-direction: column; */
        /* justify-content: flex-end; */
    }

    #chatContainer {
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column-reverse;
    }

    .bubble {
        margin: 10px 0 0;
        background: lightgray;
        border-radius: 10px 10px 10px 0;
        padding: 10px;
        width: auto;
    }
    .bubble.mine {
        border-radius: 10px 10px 0 10px;
    }
    .author {
        text-align: left;
    }

    .author.mine{
        text-align: right;
    }

    @media (min-width: 768px) {
		section {
			height: 77vh;
		}
	}

</style>

